import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecureKeyAdministrationComponent } from './component/secure-key-administration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [SecureKeyAdministrationComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ]
})
export class SecureKeyAdministrationModule { }
